import { ShowListingScreen, ShowListingScreenProps } from 'shared/screens/listings/show-listing';
import { withServerProps } from '@web/library/with-server-props';
import { Page } from '@web/components/page';

export default function ShowListing(props: ShowListingScreenProps) {
  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(props.listing.title, false)
          .setDescription(props.listing.description!)
          .setImage(props.listing.media_assets[0]?.url)
          .forListing(props.listing)
      }
    >
      <ShowListingScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(ShowListingScreen.pageBuilder);
